export default __webpack_public_path__ + "static/media/custom_webhook.2fd01ea0.svg";